import { useLocalSearchParams } from 'expo-router';
import { useMemo } from 'react';
import { ScreenContainer, Spinner, YStack } from 'smoothie';

import { useTrackViewOnFocus } from '../../../events/hooks/useTrackViewOnFocus';
import { useGetApexAccountDocuments } from '../../hooks/useGetApexAccountDocuments';
import { DocumentLinkList } from './DocumentLinkList';

export const TaxForms = () => {
    const { apexAccountId } = useLocalSearchParams<{
        apexAccountId: string;
    }>();

    const {
        isLoading: isLoadingDocuments,
        data: accountDocuments,
        getDocumentDownloadUrl,
    } = useGetApexAccountDocuments(apexAccountId);

    const taxDocuments = useMemo(
        () => accountDocuments?.taxDocuments ?? [],
        [accountDocuments],
    );

    useTrackViewOnFocus('Investment/Document/TaxForms');

    return (
        <ScreenContainer title="Tax forms" hasBackButton>
            <YStack
                width="100%"
                paddingHorizontal={32}
                gap={16}
                alignItems="flex-start"
            >
                {isLoadingDocuments ? (
                    <Spinner />
                ) : (
                    <DocumentLinkList
                        getDocumentDownloadUrl={getDocumentDownloadUrl}
                        accountDocuments={taxDocuments ?? []}
                        documentTypeName="tax forms"
                    />
                )}
            </YStack>
        </ScreenContainer>
    );
};
